import { TableCell, styled, TextField, Chip } from "@mui/material"
import { COLORS } from "../../utils"

export const PECommentHeaderCell = styled(TableCell)({
  fontSize: 20,
  padding: "16px 14px",
  textAlign: "center",
  backgroundColor: COLORS.BACKGROUND_GREY,
  color: COLORS.LABEL_GREY
})

export const PETextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
      justifyContent: "center",
      borderRadius: "8px",
      "& fieldset": {
          border: "1px solid" + COLORS.BLACK_400
      },
      "&:hover fieldset": {
          borderColor: COLORS.BLACK_300,
      },
      "&.Mui-focused fieldset": {
          borderColor: COLORS.PRIMARY_COLOR,
      },
  },
  "& .MuiInputBase-input": {
      textAlign: "center",
      width:"68px",
      fontSize: "16px",
      lineHeight: "24px",
      padding:"8px 16px",
      color: COLORS.BLACK800
  },
})

export const PEInProgressReprodChip = styled(Chip)({
  backgroundColor: "#FDF9C9",
  color: "#555",
  height:"24px",
  borderRadius: "43px",
  padding: "4px 16px",
  fontSize: "14px",
  lineHeight: "14px",
  fontWeight: 400,
  display: "inline-block",
})

export const PEDoneReprodChip = styled(Chip)({
  backgroundColor: "#CEECD6",
  color: "#555",
  height:"24px",
  borderRadius: "43px",
  padding: "4px 16px",
  fontSize: "14px",
  lineHeight: "14px",
  fontWeight: 400,
  display: "inline-block",
})
